'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageLink = function PageLink(props) {
    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)('ui-btn_paginationItem ui-btn', { 'ui-btn_primary': props.active }),
            onClick: props.active ? false : props.onClick
        },
        props.children
    );
};

PageLink.propTypes = {
    onClick: _react2.default.PropTypes.func.isRequired,
    children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string]).isRequired,
    active: _react2.default.PropTypes.bool
};

exports.default = PageLink;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-pagination/lib/components/PageLink.js
// module id = 1726
// module chunks = 1